import { component } from 'picoapp';
import './component.scss';

class Article {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.el = el;
    // this.init();
  }

  init() {
    console.log('HELLO ARTICLE');
  }
}

export default component((node, ctx) => {
  new Article(node, ctx);
});
